import type { PublicChatSession } from '@/types/public'

export type OrchestratedOrigin = 'workflow' | 'factory'

export function getPublicChatOrigin(session: PublicChatSession): 'chat' | OrchestratedOrigin {
  if (session.origin === 'workflow') return 'workflow'
  if (session.origin === 'factory') return 'factory'
  return 'chat'
}

export function filterWorkflowChats(
  sessions: PublicChatSession[],
  hideOrchestratedChats: boolean
): PublicChatSession[] {
  if (!hideOrchestratedChats) return sessions
  return sessions.filter((session) => getPublicChatOrigin(session) === 'chat')
}
